export default __webpack_public_path__ + "static/howlt-sans-reg-f13487f660554fbae998938fd3f37e5b.woff2";